exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-input-container{width: 100% !important;}\n.mat-select{margin-top: 12px !important;}\n.outer_width{width:900px;}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/nissco_event_web/angular/src/app/admin/trip/trip-edit-attendee/trip-edit-attendee.component.css
// module id = ../../../../../src/app/admin/trip/trip-edit-attendee/trip-edit-attendee.component.css
// module chunks = 39